<template>
  <!--LAYBY LANDING PAGE: Story CD-19 -->
  <h1>Layby details</h1>
</template>

<script setup lang="ts"></script>
